/* eslint-disable camelcase */
import { format } from 'date-fns';
// eslint-disable-next-line import/order
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
// TODO: Probably don't need to bundle all of these
import be from 'date-fns/locale/be';
import bg from 'date-fns/locale/bg';
import ca from 'date-fns/locale/ca';
import cs from 'date-fns/locale/cs';
import da from 'date-fns/locale/da';
import de from 'date-fns/locale/de';
import el from 'date-fns/locale/el';
import en from 'date-fns/locale/en-GB';
import eo from 'date-fns/locale/eo';
import es from 'date-fns/locale/es';
import fi from 'date-fns/locale/fi';
import fr from 'date-fns/locale/fr';
import hr from 'date-fns/locale/hr';
import hu from 'date-fns/locale/hu';
import id from 'date-fns/locale/id';
import is from 'date-fns/locale/is';
import it from 'date-fns/locale/it';
import ja from 'date-fns/locale/ja';
import ko from 'date-fns/locale/ko';
import mk from 'date-fns/locale/mk';
import nb from 'date-fns/locale/nb';
import nl from 'date-fns/locale/nl';
import pl from 'date-fns/locale/pl';
import pt from 'date-fns/locale/pt';
import ro from 'date-fns/locale/ro';
import ru from 'date-fns/locale/ru';
import sk from 'date-fns/locale/sk';
import sl from 'date-fns/locale/sl';
import sr from 'date-fns/locale/sr';
import sv from 'date-fns/locale/sv';
import th from 'date-fns/locale/th';
import tr from 'date-fns/locale/tr';
import zh_cn from 'date-fns/locale/zh-CN';
import zh_hk from 'date-fns/locale/zh-HK';
const langModulesByCode = {
    be,
    bg,
    ca,
    cs,
    da,
    de,
    el,
    en,
    eo,
    es,
    fi,
    fr,
    hr,
    hu,
    id,
    is,
    it,
    ja,
    ko,
    mk,
    nb,
    nl,
    pl,
    pt,
    ro,
    ru,
    sk,
    sl,
    sr,
    sv,
    th,
    tr,
    zh_cn,
    zh_hk,
};
const NONSTRIPPED_LOCALES = new Set(['zh-cn', 'zh-hk']);
const getLanguage = (locale) => {
    const sanitisedLocale = locale.toLowerCase();
    return NONSTRIPPED_LOCALES.has(sanitisedLocale)
        ? sanitisedLocale.replace('-', '_').toLowerCase()
        : sanitisedLocale.slice(0, 2);
};
function requestLanguage(locale) {
    const lang = getLanguage(locale);
    return langModulesByCode[lang] || en;
}
const timeAgoFrom = (time, locale) => {
    return formatDistanceToNow(time, { locale: requestLanguage(locale) });
};
const dateFormat = (date, locale) => {
    return format(date, 'dd MMM yyyy HH:mm', { locale: requestLanguage(locale) });
};
export { timeAgoFrom, dateFormat };
